import { useEffect, useState } from "react"
import { Report } from "../../interfaces/intakes.reports"
import { TempContact } from "../ui/ModalSendPDF"
import { useFindSuppliers } from "../../hooks/useFindSuppliers"
import { ModalEmailContacts } from "../modals/ModalEmailContacts"
import { IoAddCircle } from "react-icons/io5"

interface Props {
  report: Report
  mailTo: TempContact[]
  next: () => void
  closeModal: () => void
  setMailTo: React.Dispatch<React.SetStateAction<TempContact[]>>
}
export const PDF_STEPS_CONTACTS = ({ report, mailTo, setMailTo, closeModal, next }: Props) => {

  const [modalContacts, setModalContacts] = useState<boolean>(false)

  const { supplier, supplierList } = useFindSuppliers({
    team: report.team,
    reportSupplier: report.supplier || "",
    mainDataSupplier: report.mainData.supplier
  })

  useEffect(() => {

    if (supplier) {
      let supplierContacts: TempContact[] = supplier.contacts.map(contact => (
        {
          id: contact._id,
          check: true,
          name: contact.name,
          email: contact.email
        }
      ))
      setMailTo(mails => [...mails, ...supplierContacts])
    }
  }, [supplier])


  return (
    <>
      {
        modalContacts &&
        <ModalEmailContacts
          supplierList={supplierList!}
          closeModal={() => setModalContacts(false)}
          setMailTo={setMailTo}
        />
      }
      <div className='supplier-emails mb-1'>
        <h4 className='mb-1'>Supplier Contacts</h4>


        <div className='flex mb-1'>
          <p className='font-small'>Contacts</p>
          <button className='flex ml-02' onClick={() => setModalContacts(true)}><IoAddCircle /></button>
        </div>


        {
          mailTo.length > 0
            ?
            mailTo.map(contact => (
              <div key={contact.id} className="supplier-contact">
                <input
                  type="checkbox"
                  checked={contact.check}
                  onChange={() => setMailTo(mailTo.map(item => {
                    if (item.id === contact.id) {
                      return {
                        ...item,
                        check: !item.check
                      }
                    } else {
                      return item
                    }
                  }))}
                />

                <div className="ml-1">
                  <p className='font-small bold'>{contact.name}</p>
                  <p className='font-small text-mute'>{contact.email}</p>
                </div>
              </div>
            ))
            : <div className='flex-center p-1 mt-1'><p className='font-small'>No contacts found</p></div>
        }

                <div className="tw-flex tw-gap-4 tw-mt-8 tw-justify-between">
          <button className="tw-px-4 tw-py-2 tw-flex tw-gap-1 tw-items-center tw-justify-center tw-rounded-full tw-text-red-600 tw-border-2 tw-border-red-700" onClick={closeModal}>Close</button>

          <button className="tw-rounded-full tw-text-white tw-bg-blue-600 tw-px-5 tw-py-2 tw-flex tw-gap-2 tw-items-center tw-justify-center sm:tw-min-w-[8rem]" onClick={next}>Next</button>
        </div>
      </div>
    </>
  )
}
